import { defineComponent as _defineComponent } from 'vue'
import SdsDateField from '@/components/SdsDateField.vue';
import { createIdentifier } from '@/utils';
import { ref, watch } from 'vue';
import moment from 'moment';

enum ReturnTypes {
  String = 'string',
  Date = 'date',
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsDateRangeField',
  props: {
  label: {
    type: String,
    default: 'Data',
  },
  type: {
    type: String,
    // "day", "month" ou "year"
    default: 'day',
  },
  returnType: {
    type: String,
    default: 'string',
  },
  placeholderInicial: {
    type: String,
    default: undefined,
  },
  placeholderFinal: {
    type: String,
    default: undefined,
  },
},
  emits: ['change:data-inicial', 'change:data-final'],
  setup(__props, { emit }) {

const props = __props;



const uniqueId = createIdentifier('sds-date-range');
const dtInicial = ref(null);
const dtFinal = ref(null);



const getFormatFromType = () => {
  switch (props.type) {
    case 'month':
      return 'MM/YYYY';
    case 'year':
      return 'YYYY';
    default:
      return 'DD/MM/YYYY';
  }
};

watch(dtInicial, (newValue) => {
  const value =
    props.returnType === ReturnTypes.String
      ? newValue
      : moment(newValue, getFormatFromType()).toDate();

  emit('change:data-inicial', value);
});

watch(dtFinal, (newValue) => {
  const value =
    props.returnType === ReturnTypes.String
      ? newValue
      : moment(newValue, getFormatFromType()).toDate();

  emit('change:data-final', value);
});

return { __sfc: true,ReturnTypes, props, uniqueId, dtInicial, dtFinal, emit, getFormatFromType, SdsDateField }
}

})